export default __webpack_public_path__ + "static/media/Sheila Jackson Lee.cda110dd.jpg";